import { RpcBaseData } from '../rpc-base';

/**
 * RPC alive request name and version.
 */
export class RpcAliveKey {
    public static command = 'Alive';
    public static version = '0.1.0';
}

/**
 * Rpc alive data.
 */
export interface RpcAliveData extends RpcBaseData {
    /**
     * The timestamp. Date.now() / the number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
     */
    timestamp: number;

    /**
     * The flag indicating not to close the window from this tool indefinitely.
     */
    forever?: boolean;
}
